import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useMemo, useState } from 'react';
import { NumberSelectionConfig, successAvatarConfig } from './NumberSelectionConfig';
import { Callout, Collapsible, getTestId, StateConfigContext } from '@airtel/air-design-system';
import { merge } from 'lodash';
import { ChipsGroupWidget } from './components/chips-group-widget/ChipsGroupWidget';
import { getSkycFormWidgetStyles } from '../../SkycFormWidgetStyles';
import { LinkListItemWidget } from '../../../link-list-item-widget';
import { getIsDisabledState } from './NumberSelectionUtils';
import { Keyboard, View } from 'react-native';
export var NumberSelection = props => {
  var _a;
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var _useMemo = useMemo(() => merge({}, NumberSelectionConfig, props), [NumberSelectionConfig, props]),
    _state = _useMemo.state,
    successStateHeading = _useMemo.successStateHeading,
    isExpanded = _useMemo.isExpanded,
    disableToggle = _useMemo.disableToggle,
    _useMemo$chipsList = _useMemo.chipsList,
    chipsList = _useMemo$chipsList === void 0 ? [] : _useMemo$chipsList,
    _calloutProps = _useMemo.stepCalloutProps,
    onUserAction = _useMemo.onUserAction,
    _useMemo$testID = _useMemo.testID,
    testID = _useMemo$testID === void 0 ? 'ChipsGroupWidget' : _useMemo$testID,
    numOfColumns = _useMemo.numOfColumns,
    buttonWidgetData = _useMemo.buttonWidgetData,
    onChipPressMetaData = _useMemo.onChipPressMetaData,
    onStepDetailsListItemPressMetaData = _useMemo.onStepDetailsListItemPressMetaData,
    onStepDetailsCtaPressMetaData = _useMemo.onStepDetailsCtaPressMetaData,
    style = _useMemo.style,
    variant = _useMemo.variant,
    withCollapsible = _useMemo.withCollapsible,
    selectedChipIndex = _useMemo.selectedChipIndex,
    _stepDetails = _useMemo.stepDetailsProps,
    calloutProps = _useMemo.calloutProps;
  var _useState = useState((_a = _stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.subHeading) !== null && _a !== void 0 ? _a : ''),
    subHeading = _useState[0],
    setSubHeading = _useState[1];
  var _useState2 = useState(_calloutProps),
    stepCalloutProps = _useState2[0],
    setStepCalloutProps = _useState2[1];
  var _useState3 = useState(isExpanded),
    isExpandedState = _useState3[0],
    setIsExpandedState = _useState3[1];
  var _useState4 = useState(_state),
    stateType = _useState4[0],
    setStateType = _useState4[1];
  var isDisabledState = stateType === 'disabled';
  var isSuccessState = stateType === 'success';
  var skycFormWidgetStyle = getSkycFormWidgetStyles(props);
  useEffect(() => {
    setStateType(_state);
    setIsExpandedState(_state === 'none');
  }, [_state]);
  useEffect(() => {
    setIsExpandedState(isExpanded);
    if (!isExpanded) Keyboard.dismiss();
  }, [isExpanded]);
  useEffect(() => {
    setSubHeading(_stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.subHeading);
  }, [_stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.subHeading]);
  useEffect(() => {
    setStepCalloutProps(prev => Object.assign(Object.assign({}, prev), _calloutProps || {}));
  }, [JSON.stringify(_calloutProps)]);
  var handleChangeButtonPress = () => {
    setIsExpandedState(true);
  };
  var chipsGroupWidget = _jsx(ChipsGroupWidget, {
    onChipPressMetaData: onChipPressMetaData,
    buttonWidgetData: buttonWidgetData,
    numOfColumns: numOfColumns,
    chipsList: chipsList,
    calloutProps: calloutProps,
    selectedChipIndex: selectedChipIndex,
    onUserAction: onUserAction
  });
  return withCollapsible ? _jsx(Collapsible, Object.assign({
    theme: theme,
    childPaddingToken: "SPACING_0",
    titlePaddingToken: "SPACING_0",
    showIcon: false,
    style: [skycFormWidgetStyle.heading, style],
    titleNoVerticalPadding: true,
    titleNoHorizontalPadding: true,
    withCard: true
  }, getTestId(testID, variant + "_Collapsible"), {
    isExpanded: isExpandedState,
    disabled: getIsDisabledState(isDisabledState, disableToggle),
    titleComponent: _jsxs(View, Object.assign({
      style: skycFormWidgetStyle.stepCardTitle
    }, {
      children: [_jsx(LinkListItemWidget, Object.assign({}, _stepDetails, isSuccessState && !isExpandedState && successStateHeading && {
        heading: successStateHeading
      }, {
        roundedCorners: true,
        theme: theme
      }, getTestId(testID, variant + "_LinkListItemWidget"), {
        noHoverEffect: true,
        noPressEffect: true,
        onPress: onStepDetailsListItemPressMetaData,
        onUserAction: onUserAction,
        actionTypeProps: !isExpandedState && !isDisabledState && (_stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.actionTypeProps),
        actionTypeOnPressMetaData: onStepDetailsCtaPressMetaData,
        actionTypeOnPress: handleChangeButtonPress
      }, isSuccessState && Object.assign({}, successAvatarConfig), isSuccessState && !isExpandedState && {
        subHeading: subHeading
      }, {
        disabled: getIsDisabledState(isDisabledState, _stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.disabled),
        subHeadingNumberOfLines: (_stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.subHeadingNumberOfLines) || 1
      })), !isExpandedState && stepCalloutProps && _jsx(Callout, Object.assign({}, stepCalloutProps, getTestId(testID, 'callout'), {
        style: [skycFormWidgetStyle.calloutContainer, stepCalloutProps === null || stepCalloutProps === void 0 ? void 0 : stepCalloutProps.style]
      }))]
    }))
  }, {
    children: _jsx(View, Object.assign({
      style: skycFormWidgetStyle.content
    }, {
      children: chipsGroupWidget
    }))
  })) : chipsGroupWidget;
};